"use client";

import { ChatHelpIcon, CheckmarkBadgeIcon, DismissCircleIcon } from "@/app/_components/icons";
import { cn } from "@/lib/utils";

export interface SuccessModalPropertyCard {
  address: string;
  price: string;
  saleType?: string;
}

export interface SuccessModalProps {
  title: string;
  subheading: string;
  label: string;
  onBackToHome?: () => void;
  extraButton?: boolean;
  extraButtonLabel?: string;
  extraButtonOnClick?: () => void;
  onClose?: () => void;
  onHelpClick?: () => void;
  className?: string;
}

export function SuccessModal({
  title,
  subheading,
  label,
  onBackToHome,
  extraButton,
  extraButtonLabel,
  extraButtonOnClick,
  onClose,
  onHelpClick,
  className,
}: SuccessModalProps) {
  return (
    <div className={cn("flex flex-col bg-white p-6", className)}>
      {(onHelpClick != null || onClose != null) && (
        <div className="flex justify-end gap-2 pb-2">
          {onHelpClick != null && (
            <button
              type="button"
              onClick={onHelpClick}
              className="text-typography-600 hover:text-typography-900 flex size-8 items-center justify-center rounded-full transition-colors"
              aria-label="Help">
              <ChatHelpIcon className="size-5" />
            </button>
          )}
          {onClose != null && (
            <button
              type="button"
              onClick={onClose}
              className="text-typography-600 hover:text-typography-900 flex size-8 items-center justify-center rounded-full transition-colors"
              aria-label="Close">
              <DismissCircleIcon className="size-4 md:size-5" />
            </button>
          )}
        </div>
      )}

      <div className="flex justify-center pb-4">
        <div className="bg-success-100 flex size-16 items-center justify-center rounded-full md:size-20">
          <CheckmarkBadgeIcon className="text-primary-600 size-10 md:size-12" />
        </div>
      </div>

      <div className="py-4 sm:py-6">
        <h2 className="text-typography-900 text-center text-2xl leading-tight font-bold md:text-2xl">
          {title}
        </h2>

        <p className="text-secondary-700 mx-auto mt-2 max-w-md text-center text-sm leading-[20px] font-normal md:text-base">
          {subheading}
        </p>
      </div>

      {extraButton ? (
        <div className="flex items-center justify-center gap-3">
          <button
            type="button"
            onClick={extraButtonOnClick}
            className="border-border text-typography-800 text-md mt-6 inline-flex h-full min-w-[96px] cursor-pointer items-center justify-center rounded-sm border px-6 py-2.5 font-medium hover:bg-white">
            {extraButtonLabel}
          </button>

          <button
            type="button"
            onClick={onBackToHome}
            className="bg-primary-700 text-primary-0 hover:bg-primary-700 mt-6 w-full cursor-pointer rounded-sm px-6 py-3 text-base font-semibold transition-colors">
            {label}
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={onBackToHome}
          className="bg-primary-700 text-primary-0 hover:bg-primary-700 mt-6 w-full cursor-pointer rounded-sm px-6 py-3 text-base font-semibold transition-colors">
          {label}
        </button>
      )}
    </div>
  );
}
